import React, { Component } from 'react';
import Picker from 'react-mobile-picker-scroll';
import moment from 'moment';
import './styles.scss';
import PropTypes from 'prop-types';
import I18n from 'hooks/useI18n';

// Canonical month keys — never shown to the user directly, only used to look up the
// translated label (MonthsShort.<key> in the i18n files) and to resolve a translated
// label back to a month index for the day-count/leap-year/Date-construction logic below.
const MONTHS_EN = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

function getMonthLabels() {
  return MONTHS_EN.map(month => I18n.t(`MonthsShort.${month}`));
}

function translateMonth(monthEn) {
  return I18n.t(`MonthsShort.${monthEn}`);
}

class ScrollPickerBirthday extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // currentMonthAsInt: null,
      expandPicker: true,
      isMaxYear: false,
      maxMonthEnd: null,
      day28: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28],
      day29: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29],
      day30: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
      day31: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      valueGroups: {
        day: null,
        month: null,
        year: null,
      },
      optionGroups: {
        day: [this.props.userSelectedDay],
        month: [translateMonth(this.props.userSelectedMonth)],
        year: [this.props.userSelectedYear],
      },
    };

    this.handleUpdateDate = this.handleUpdateDate.bind(this);
    this.toggleCurrentSelectedBirthday = this.toggleCurrentSelectedBirthday.bind(this);
    this.togglePicker = this.togglePicker.bind(this);
  }

  componentDidMount() {
    /* Create an array containing the last 90 years as selection options counting
    back from 'maxYear' which subtracts 18 to ensure min age requirement */
    this.toggleCurrentSelectedBirthday();
    const yearSelectionOptions = [];
    const maxYear = moment().subtract(19, 'year');
    let year = moment(maxYear).year();
    let i;
    for (i = 0; i < 90; i += 1) {
      if (i === 0) {
        yearSelectionOptions.push(year);
      } else {
        year -= 1;
        yearSelectionOptions.push(year);
      }
    }

    this.setState({
      optionGroups: {
        ...this.state.optionGroups,
        year: yearSelectionOptions,
        month: getMonthLabels(),
        day: this.formatMonth(translateMonth(this.props.userSelectedMonth), this.props.userSelectedYear),
      },
    });
  }

  componentWillReceiveProps(nextProps, nextState) {
    if (
      nextProps.keyCheckSexual !== this.props.keyCheckSexual ||
      nextProps.userSelectedDay !== this.props.userSelectedDay ||
      nextProps.userSelectedMonth !== this.props.userSelectedMonth ||
      nextProps.userSelectedYear !== this.props.userSelectedYear
    ) {
      this.handleUpdateDate(nextProps.userSelectedDay, nextProps.userSelectedMonth, nextProps.userSelectedYear);
    }
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevState.expandPicker !== this.state.expandPicker && !this.state.expandPicker) {
      this.props.handleUpdateBirthday();
    }
  }

  handleUpdateDate(day, month, year) {
    const translatedMonth = translateMonth(month);
    const valueGroups = {
      day,
      month: translatedMonth,
      year,
    };
    const optionGroups = {
      ...this.state.optionGroups,
      day: this.formatMonth(translatedMonth, year),
    };
    this.setState({
      valueGroups,
      optionGroups,
    });
  }

  toggleCurrentSelectedBirthday() {
    const valueGroups = {
      day: this.props.userSelectedDay,
      month: translateMonth(this.props.userSelectedMonth),
      year: this.props.userSelectedYear,
    };
    this.setState({
      valueGroups,
    });
  }

  togglePicker() {
    const { expandPicker } = this.state;
    this.setState({ expandPicker: !expandPicker }, () => {
      if (!this.state.expandPicker) {
        this.props.handleUpdateBirthday();
      }
    });
  }

  // userSelectedMonth is the translated label shown in the picker (MonthsShort.<key>),
  // so resolve it back to the canonical month index before doing any day-count logic.
  formatMonth(userSelectedMonth, userSelectedYear) {
    let selectedDayType;
    const monthIndex = getMonthLabels().indexOf(userSelectedMonth);
    const isLeapYear = userSelectedYear % 400 === 0 || (userSelectedYear % 4 === 0 && userSelectedYear % 100 !== 0);
    if (monthIndex === 1 && !isLeapYear) {
      // Feb
      selectedDayType = this.state.day28;
    } else if (monthIndex === 1 && isLeapYear) {
      // Feb (leap year)
      selectedDayType = this.state.day29;
    } else if ([0, 2, 4, 6, 7, 9, 11].includes(monthIndex)) {
      // Jan, Mar, May, Jul, Aug, Oct, Dec
      selectedDayType = this.state.day31;
    } else {
      selectedDayType = this.state.day30;
    }
    return selectedDayType;
  }

  formatMaxDay(value) {
    setTimeout(() => {
      if (this.state.isMaxYear) {
        console.log('SELECTED MONTH');
        console.log(value);
        console.log(this.state.maxMonthEnd);

        // if month is current month reduce the available days to current day
        if (this.state.maxMonthEnd === value) {
          const today = new Date();
          const maxDay = today.getDate();
          const d = Array(...{ length: maxDay + 1 }).map(Number.call, Number);
          const maxDayArray = d.slice(1);
          console.log(maxDayArray);

          this.setState(({ optionGroups }) => ({
            optionGroups: {
              ...optionGroups,
              day: maxDayArray,
            },
          }));
        }
      }
    }, 100);
  }

  formatMaxYear(value) {
    // console.log("year value", value);
    const maxYear = moment().subtract(19, 'year').year();
    // console.log("maxYear", maxYear);
    if (value === maxYear) {
      // this.setState({isMaxYear: true});
      //
      // var maxMonthOfCurrentYear = moment().subtract(19, "year").month() + 1;
      //
      // var monthInt = parseInt(this.state.currentMonthAsInt);
      //
      // var current = 1;
      // if (this.state.maxMonthEnd === 'Jan') {current = 1};
      // if (this.state.maxMonthEnd === 'Feb') {current = 2};
      // if (this.state.maxMonthEnd === 'Mar') {current = 3};
      // if (this.state.maxMonthEnd === 'Apr') {current = 4};
      // if (this.state.maxMonthEnd === 'May') {current = 5};
      // if (this.state.maxMonthEnd === 'Jun') {current = 6};
      // if (this.state.maxMonthEnd === 'Jul') {current = 7};
      // if (this.state.maxMonthEnd === 'Aug') {current = 8};
      // if (this.state.maxMonthEnd === 'Sep') {current = 9};
      // if (this.state.maxMonthEnd === 'Oct') {current = 10};
      // if (this.state.maxMonthEnd === 'Nov') {current = 11};
      // if (this.state.maxMonthEnd === 'Dec') {current = 12};
      //
      // if (monthInt === current) {
      //
      //   console.log('IS MONTH END');
      //
      //   var today = new Date();
      //   var maxDay = today.getDate();
      //   var d = Array.apply(null, {length: maxDay+1}).map(Number.call, Number);
      //   var maxDayArray = d.slice(1);
      //   console.log(maxDayArray);
      //   setTimeout(() => {
      //     this.setState(({optionGroups}) => ({
      //       optionGroups: {
      //         ...optionGroups,
      //         day: maxDayArray
      //       }
      //     }));
      //   },100);
      // }
      //
      // var amountOfMonthsToSubtract = ((12 - maxMonthOfCurrentYear));
      // var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      // var maxMonth = months.slice(0,-amountOfMonthsToSubtract);
      //
      // var maxMonthEnd = months.slice(-amountOfMonthsToSubtract-1,-amountOfMonthsToSubtract);
      // this.setState({maxMonthEnd: maxMonthEnd.toString()});
      // this.setState(({optionGroups}) => ({
      //   optionGroups: {
      //     ...optionGroups,
      //     month: maxMonth
      //   }
      // }));
    } else {
      // var currentSelectedMonth = maxMonthEnd;
      //
      // var selectedDayType = [];
      // if (currentSelectedMonth === 'Feb') {
      //   selectedDayType = this.state.day28
      // } else if
      // (currentSelectedMonth === 'Jan' ||
      //   currentSelectedMonth === 'Mar' ||
      //   currentSelectedMonth === 'May' ||
      //   currentSelectedMonth === 'Jul' ||
      //   currentSelectedMonth === 'Aug' ||
      //   currentSelectedMonth === 'Oct' ||
      //   currentSelectedMonth === 'Dec') {
      //   selectedDayType = this.state.day31
      // } else {
      //   selectedDayType = this.state.day30
      // }
      //
      // this.setState(({optionGroups}) => ({
      //   optionGroups: {
      //     ...optionGroups,
      //     day: selectedDayType,
      //   }
      // }));
      // this.setState({isMaxYear: false});
      this.setState(({ optionGroups }) => ({
        optionGroups: {
          ...optionGroups,
          month: getMonthLabels(),
        },
      }));
    }
  }

  resetDays() {}
  // Update the value in response to user picking event
  handleChange = (name, value) => {
    if (name === 'year') {
      this.formatMaxYear(value);
    }

    if (name === 'month') {
      this.formatMaxDay(value);
      const selectedDayType = this.formatMonth(value, this.state.valueGroups.year);
      this.setState(({ optionGroups }) => ({
        optionGroups: {
          ...optionGroups,
          day: selectedDayType,
        },
      }));
    }
    this.setState(
      ({ valueGroups }) => ({
        valueGroups: {
          ...valueGroups,
          [name]: value,
        },
      }),
      () => {
        // valueGroups.month holds the translated label; resolve it back to the
        // canonical 1-based month number for the Date constructor below.
        const monthAsInt = getMonthLabels().indexOf(this.state.valueGroups.month) + 1;

        const day = parseInt(this.state.valueGroups.day);
        const d = new Date(this.state.valueGroups.year, monthAsInt - 1, day, 12, 30, 0, 0);
        const jsonDate = d.toJSON();
        this.props.onChange(moment(jsonDate).format());
        //
        // this.props.addDay(this.state.valueGroups.day);
        // this.props.addMonth(this.state.valueGroups.month);
        // this.props.addYear(this.state.valueGroups.year);
      }
    );
  };

  render() {
    const { optionGroups, valueGroups } = this.state;
    const { height } = this.props;
    return (
      <div className="scroll-popup">
        <div className="scroll-picker">
          <Picker optionGroups={optionGroups} valueGroups={valueGroups} onChange={this.handleChange} height={height} />
        </div>
      </div>
    );
  }
}

ScrollPickerBirthday.defaultProps = {
  height: 300,
};

ScrollPickerBirthday.propTypes = {
  keyCheckSexual: PropTypes.number,
  onChange: PropTypes.func,
  handleUpdateBirthday: PropTypes.func,
  userSelectedDay: PropTypes.number,
  userSelectedMonth: PropTypes.number,
  userSelectedYear: PropTypes.number,
  height: PropTypes.number,
};
export default ScrollPickerBirthday;
